"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isScalarType = void 0;
const scalarTypes_1 = require("./scalarTypes");
const isScalarType = function ({ type }) {
    return Boolean(scalarTypes_1.scalarTypes[type]);
};
exports.isScalarType = isScalarType;
